import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ExerciseStatus } from '@datacamp/exercise-contract';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import selectLastSubmission from '../selectors/selectLastSubmission';
import selectLostXp from '../selectors/selectLostXp';
export class LifecycleComponent extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "render", () => null);
  }
  componentDidMount() {
    const {
      exercise,
      exerciseId
    } = this.props;
    this.checkExerciseStatus({
      exercise
    });
    if (exercise === undefined) {
      return;
    }
    this.checkExerciseReady({
      currentExerciseId: exerciseId
    });
  }
  componentDidUpdate(prevProps) {
    const {
      exercise,
      exerciseId,
      lastSubmission,
      lostXp
    } = this.props;
    this.checkExerciseStatus({
      exercise
    });
    if (exercise === undefined) {
      return;
    }
    this.checkExerciseReady({
      currentExerciseId: exerciseId,
      previousExerciseId: prevProps.exercise === undefined ? undefined : prevProps.exerciseId
    });
    this.checkXp({
      exercise,
      exerciseId,
      lostXp,
      prevExercise: prevProps.exercise,
      prevLostXp: prevProps.lostXp
    });
    this.checkLastSubmission({
      exerciseId,
      lastSubmission,
      prevLastSubmission: prevProps.lastSubmission
    });
  }
  checkExerciseReady(_ref) {
    let {
      currentExerciseId,
      previousExerciseId
    } = _ref;
    const {
      onExerciseReady
    } = this.props;
    if (previousExerciseId === undefined || previousExerciseId !== currentExerciseId) {
      onExerciseReady({
        id: currentExerciseId
      });
    }
  }
  checkExerciseStatus(_ref2) {
    let {
      exercise
    } = _ref2;
    const {
      exerciseId,
      onExerciseStatusUpdate
    } = this.props;
    if (exercise === undefined) {
      onExerciseStatusUpdate({
        id: exerciseId,
        status: ExerciseStatus.BUSY
      });
    } else {
      onExerciseStatusUpdate({
        id: exerciseId,
        status: ExerciseStatus.READY
      });
    }
  }
  checkXp(_ref3) {
    let {
      exercise,
      exerciseId,
      lostXp,
      prevExercise,
      prevLostXp
    } = _ref3;
    const {
      onXpUpdated
    } = this.props;
    if (prevExercise === undefined) {
      return;
    }
    if (exercise.xp !== prevExercise.xp || lostXp !== prevLostXp) {
      const newXp = exercise.xp - lostXp;
      onXpUpdated({
        id: exerciseId,
        xp: newXp
      });
    }
  }
  checkLastSubmission(_ref4) {
    let {
      exerciseId,
      lastSubmission,
      prevLastSubmission
    } = _ref4;
    const {
      onExerciseSubmitted
    } = this.props;
    if (lastSubmission !== undefined && lastSubmission !== prevLastSubmission) {
      onExerciseSubmitted({
        correct: lastSubmission.success,
        id: exerciseId,
        message: lastSubmission.message,
        submission: lastSubmission.submittedCode
      });
    }
  }
}
export default connect((state, _ref5) => {
  let {
    exerciseId
  } = _ref5;
  return {
    lastSubmission: selectLastSubmission(state, exerciseId),
    lostXp: selectLostXp(state, exerciseId)
  };
})(LifecycleComponent);